
/**
 * Extracts user-friendly error message from league mutation errors
 */
export const extractLeagueErrorMessage = (error: any): string => {
  // Handle Supabase error object
  if (error && typeof error === 'object') {
    if ('message' in error) {
      return error.message as string;
    }
    if ('details' in error) {
      // Check for unique constraint violations
      if (error.details?.includes('already exists')) {
        return "This league already exists for the selected country.";
      }
      // Check for foreign key violations
      if (error.details?.includes('violates foreign key constraint')) {
        return "The selected country does not exist in the database.";
      }
      return error.details as string;
    }
  }
  
  return "Failed to add league. Please try again.";
};
